import { render, staticRenderFns } from "./CompanyLog.vue?vue&type=template&id=5785918c&scoped=true"
import script from "./CompanyLog.vue?vue&type=script&lang=js"
export * from "./CompanyLog.vue?vue&type=script&lang=js"
import style0 from "./CompanyLog.vue?vue&type=style&index=0&id=5785918c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5785918c",
  null
  
)

export default component.exports